import { FormController } from '@dreryk/react-components';

import { VisitSettlementFormController } from '../VisitSettlementForm';

import { PaymentFormBean } from './payment.types';

type PaymentControllerProps = Pick<VisitSettlementFormController, 'register'> & {
   readonly name: keyof PaymentFormBean;
};

export const PaymentController = (props: PaymentControllerProps): JSX.Element => {
   return <FormController controller={props.register(`payment.${props.name}`)} />;
};
